import * as moment from 'moment';

export * from './calendar-text';
export * from './calendar-settings';

import { IEvent } from '../custom/classes/event';

export interface IOption {
    text: string;
    value: string;
    /**
     * This is a DateTime string in ISO format.
     */
    firstOccurance: string;
}

/**
 * Enum representing each day in the week.
 */
export enum Weekday {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export interface ICalendarService<T extends IEvent> {
    (options: ICalendarOptions<T>): ICalendar<T>;
}


export interface ICalendarOptions<T extends IEvent> {
    month: number;
    year: number;
    weekStart?: number;
    days?: Array<IDay<T>>;
    events?: Array<T>;
    weekdayNames?: Array<string>;
}


export interface ICalendar<T extends IEvent> {
    days: Array<IDay<T>>;
    allDays: Array<IDay<T>>;
    weeks: Array<IWeek<T>>;
    weekdays: Array<string>;
}

export interface IDay<T extends IEvent> {
    date: Date;
    events?: Array<T>;
}


export interface IWeek<T extends IEvent> {
    days: Array<IDay<T>>
}

export interface IMonth<T extends IEvent> {
    monthMoment: moment.Moment;
    events: ICalendar<T>;
}


export interface IBaseEvent {
    id: string;
    /**
     * The date of the event. This is not a moment object because it's pulled from the API.
     * Potential optimization if necessary is to convert to a moment object when data is pulled.
     */
    eventDate: Date | string;
    eventDateString: string;
    eventTimeString: string;
    name?: string;
    location?: string;
    thumbnail?: string;
    synopsis?: string;
    buyTicketCtaUrl?: string;
    buyTicketCtaText?: string;
    viewDetailCtaUrl?: string;
    viewDetailCtaText?: string;
    categories?: string[];
    // custom event fields
    gridAvailabilityStatus: string;
    listAvailabilityStatus: string;
    gridInformationStatus: string;
    listInformationStatus: string;
    hideCta: boolean;
    calendarRollover?: string;
}


export interface IDateRange {
    start: Date;
    end: Date;
}


export interface ICalendarState<T extends IEvent> {
    updating: boolean;
    specificDates: boolean;
    extendEvents: boolean;
    startDate: moment.Moment;
    endDate: moment.Moment;
    currentDate: moment.Moment;
    eventFilter: IEventFilter[];
    filterFunction: (event: IEvent) => boolean;
    productionSeasonFilter: number;
    events: IMonth<T>[];
    apiError: any;
}

export const defaultCalendarModel: ICalendarState<IEvent> = {
    updating: false,
    specificDates: false,
    extendEvents: false,
    startDate: moment(moment().startOf('month')),
    endDate: moment(moment().endOf('month')),
    currentDate: moment().clone(),
    eventFilter: [],
    productionSeasonFilter: 0,
    filterFunction: () => { return true; },
    events: [{
        monthMoment: moment(),
        events: {
            allDays: [],
            days: [],
            weekdays: [],
            weeks: []
        }
    }],
    apiError: null
};

//export interface IProductionSeasonFilter {
//    productionSeasonId: number;
//    productionName: string;
//}

export interface IEventFilter {
    key: string;
    selectedValue: any;
    filter: (event: IEvent) => boolean;
}
